import { Navigate, Outlet } from "react-router-dom";
import { ROOT } from "@/routes";
import { CONFIG } from "@/config";

export const RequireDevelopment = ({ children }: { children?: React.ReactNode } = {}) => {
  const isDevelopmentMode = CONFIG.IS_DEVELOPMENT;

  if (!isDevelopmentMode) {
    return <Navigate to={ROOT()} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
